import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { CampaignRegisterResponse } from '@/repositories/generated';

const response: CampaignRegisterResponse = { id: '1' };

export const campaignRegister = http.post(
  createMockEndpoint('/campaign'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
